import { render, staticRenderFns } from "./FeatureSettings.vue?vue&type=template&id=4efc61b2&"
import script from "./FeatureSettings.vue?vue&type=script&lang=js&"
export * from "./FeatureSettings.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports